import { Empty, Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { spacing } from '../../theming';
import { cardStyle, cardTitleStyle, mutedSmallStyle } from './vinExtractionStyles';
import { useNumberFormat } from './useNumberFormat';
import FailureReasonRow from './FailureReasonRow';

/** "Failure reasons": each reason's share of the failed cars, in the order the API sends; not found is separate. */
export default function FailureReasons({ reasons, failed, notFound }) {
    const { t } = useTranslation('vinExtraction');
    const { integer } = useNumberFormat();

    return (
        <Flex vertical gap={spacing[2]} style={{ ...cardStyle, height: '100%' }}>
            <Flex vertical>
                <span style={cardTitleStyle}>{t('stats.reasons.title')}</span>
                <span style={mutedSmallStyle}>
                    {t('stats.reasons.subtitle', {
                        failed: integer(failed),
                        notFound: integer(notFound),
                    })}
                </span>
            </Flex>
            {reasons.length === 0 ? (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('stats.reasons.empty')} />
            ) : (
                <Flex vertical gap={spacing[2]} role="list">
                    {reasons.map(({ reason, count, share }) => (
                        <FailureReasonRow key={reason} reason={reason} count={count} share={share} />
                    ))}
                </Flex>
            )}
        </Flex>
    );
}
